/**
 * V3 — Axios instance avec credentials includes pour cookies.
 */
import axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30000,
});

export async function getDashboard() {
  const { data } = await api.get('/api/v3/dashboard');
  return data;
}

export async function getJournal({ from, to, search, page = 1, page_size = 30 } = {}) {
  const params = {};
  if (from) params.from_date = from;
  if (to) params.to_date = to;
  if (search) params.search = search;
  params.page = page;
  params.page_size = page_size;
  const { data } = await api.get('/api/v3/journal', { params });
  return data;
}

export function journalExportUrl({ from, to } = {}) {
  const params = new URLSearchParams();
  if (from) params.set('from_date', from);
  if (to) params.set('to_date', to);
  return `${baseURL}/api/v3/journal/export.xlsx${params.toString() ? '?' + params : ''}`;
}

export async function authMe() {
  const { data } = await api.get('/api/v3/auth/me');
  return data;
}

export async function authSession(sessionId) {
  const { data } = await api.post('/api/v3/auth/session', null, {
    headers: { 'X-Session-ID': sessionId }
  });
  return data;
}

export async function authLogout() {
  await api.post('/api/v3/auth/logout');
}

// ============================================================
// AUDIT LOG (CEO admin only — /api/v3/audit/*)
// ============================================================
export async function auditRecent({ limit = 100, action = '', key_search = '' } = {}) {
  const params = { limit };
  if (action) params.action = action;
  if (key_search) params.key_search = key_search;
  const { data } = await api.get('/api/v3/audit/recent', { params });
  return data;
}

export async function auditDeleted() {
  const { data } = await api.get('/api/v3/audit/deleted');
  return data;
}

export async function auditDeletedValue(key) {
  const { data } = await api.get('/api/v3/audit/deleted/' + encodeURIComponent(key));
  return data;
}

export async function auditRestore(key) {
  const { data } = await api.post('/api/v3/audit/restore/' + encodeURIComponent(key));
  return data;
}

export async function auditPurge(key) {
  const { data } = await api.delete('/api/v3/audit/purge/' + encodeURIComponent(key));
  return data;
}

export async function auditStats() {
  const { data } = await api.get('/api/v3/audit/stats');
  return data;
}

export async function auditRescueStatus() {
  const { data } = await api.get('/api/v3/audit/rescue-status');
  return data;
}

export function auditExportCsvUrl({ action = '', key_search = '', limit = 1000 } = {}) {
  const params = new URLSearchParams();
  if (action) params.set('action', action);
  if (key_search) params.set('key_search', key_search);
  params.set('limit', String(limit));
  return `${baseURL}/api/v3/audit/export.csv?${params.toString()}`;
}
